module.exports = __webpack_public_path__ + "img/image.31ab2d8c.svg";